<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import UserGroupForm from '@/components/user-groups/UserGroupForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const emit = defineEmits(['created']);

    const form = useForm({
        name: '',
        user_ids: [],
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.user-groups.store')"
        :query-key="[QueryKey.USER_GROUPS]"
        title="user-groups.user_groups_create"
        success-message="user-groups.created"
        button-text="user-groups.user_groups_create"
    >
        <UserGroupForm :form="form" />
    </DialogForm>
</template>
